export default {
  LANG_CODE: 'nl',
  LANG_NOT_FOUND: 'Currently We ondersteunen de taal die u probeert te selecteren niet.',
  LANG_HAS_DELETED: 'Currently We ondersteunen de geselecteerde taal niet, neem dan contact op met ons ondersteuningsteam.',
  USER_ID: 'Gebruikersnaam',
  USER_NAME: 'Gebruikersnaam',
  PASSWORD: 'Wachtwoord',
  REQUIRED_FIELD: 'is een verplicht veld',
  FORGOT_PASSWORD: 'Wachtwoord vergeten',
  API_DEFAULT_ERROR: 'Er is iets misgegaan, probeer het na enige tijd opnieuw.',
  SUPPORT_LABEL: 'Neem voor problemen met inloggen of wachtwoorden contact op met',
  BACK_TO_LOGIN: 'Terug naar inloggen',
  SUBMIT: 'Opslaan',
  YES: 'Ja',
  NO: 'Nee',
  DELETE: 'Verwijderen',
  LOGOUT: 'Logout',
  LOGOUT_POPUP_TITLE: 'Wil je uitloggen?',
  EVENT_INFO: 'Informatie over het evenement',
  QUALIFYING_QUESTIONS: 'Kwalificerende vragen',
  CONTENT: 'Content',
  EMAILS: 'E-mailadressen',
  PREVIOUS: 'Vorig',
  CONTINUE: 'Voortzetten',
  FINISH: 'Fins',
  ADD: 'Toevoegen',
  CANCEL: 'Annuleren',
  APPROVE: 'Goedkeuren',
  INVALID_FIELD: 'veld is ongeldig',
  SET: 'Set',
  EXHIBITORS: 'Tentoonstellingen',
  EVENT_ID: 'Gebeurtenis-Id',
  PASS_MIN_LEN_ERROR: 'moet ten minste 6 tekens bevatten.',
  SAVE: 'Redden',
  EDIT: 'Bewerken',
  COOCKIE_POLICY: 'Cookiebeleid',
  COOCKIE_TEXT:
    'Cookies helpen ons om onze diensten aan te bieden. We gebruiken technische cookies om u de beste ervaring van onze site te bieden. Door dit venster te sluiten of door de site te blijven gebruiken, gaat u akkoord met ons gebruik van dergelijke cookies. Lees meer in onze',
  COOCKIE_POLICY_LINK: 'https://fielddrive.com/cookie-policy/',
  SUCCESS_TITLE: 'Succes!',
  FAILED_TITLE: 'Mislukt!',
  OR: 'Of',
  EVENT_SETTINGS: 'Evenementinstellingen',
  LEADS: 'Leidt',
  COPIED: 'Copied!',
  PREVIEW: 'Preview',
  RENAME: 'Rename',
  DELETE_LABEL: 'Wil je dit verwijderen'
}
